import { getApiErrorMessage } from "@/lib/apiErrors";

/**
 * The `{ ok, message }` a recipe manager callback returns for an RTK mutation
 * result. The message comes from the shared API error helper, so it is French
 * and never the server's own text (SFRESTO-172).
 */
export function recipeMutationResult(
  res: { data: unknown } | { error: unknown },
  fallback: string
): { ok: boolean; message?: string } {
  if ("data" in res) return { ok: true };
  return { ok: false, message: getApiErrorMessage(res.error, fallback) };
}
